module.exports = __webpack_public_path__ + "img/face.bd8a6d60.png";